var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPokemonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "351.61 350.21 496.83 499.59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m600.05 350.21c128.34 0 235.87 96.281 248.39 223.31h-163.31c-11.156-36.281-44.625-62.859-85.125-62.859-40.453 0-73.922 26.578-85.125 62.859h-163.26c13.969-127.03 121.36-223.31 248.44-223.31zm0 198.14c29.344 0 53.062 22.312 53.062 51.656s-23.719 53.062-53.062 53.062c-29.297 0-51.656-23.719-51.656-53.062 0-29.297 22.312-51.656 51.656-51.656zm248.34 78.234c-12.469 126.98-120 223.22-248.34 223.22-127.03 0-234.42-96.281-248.44-223.26l163.31 0.046875c11.156 36.234 44.625 62.766 85.125 62.766s73.922-26.578 85.125-62.766z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokemonIcon);
export default __webpack_public_path__ + "static/media/pokemon-icon.d36b6f0655c180980d5acb3287a88011.svg";
export { ForwardRef as ReactComponent };